import { createContext } from "react";

import type { TFieldsLoadingContext } from "../types";

const OrderFieldsLoadingContext = createContext<TFieldsLoadingContext | undefined>(undefined);
export default OrderFieldsLoadingContext;
